import { render, staticRenderFns } from "./Horizon.vue?vue&type=template&id=4b3bef9b"
import script from "./Horizon.vue?vue&type=script&lang=js"
export * from "./Horizon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports